// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__bp8Om","footer":"ChangeClinic_footer__1eJJW"};